import { getAuthTokenCookieValue } from './get-auth-token-cookie-value';
import { getDomainForCookie } from './get-domain-for-cookie';

export function clearAuthCookie() {
    if (getAuthTokenCookieValue()) {
        const name = 'AUTH_TOKEN';
        const path = '/';
        const domain = getDomainForCookie();
        document.cookie =
            name +
            '=' +
            (path ? ';path=' + path : '') +
            (domain ? ';domain=' + domain : '') +
            ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
}
